<template>
  <v-dialog v-model="dialog" width="400px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text"
        ><v-toolbar-title>THÊM BỘ MÔN MỚI</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="dialog = false">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            outlined
            dense
            v-model="title"
            class="required mt-4"
            :rules="[$rules.required]"
            label="Tên bộ môn"
          />
          <!-- <CheckboxAcademicLevel @change="academicLevels = $event" /> -->
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-row class="ma-2" no-gutters>
          <v-btn class="px-4" outlined light depressed @click="cancel">Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="px-4" dark depressed color="#0D47A1" :loading="loading" @click="save"
            ><v-icon left>add</v-icon>Thêm</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
// import CheckboxAcademicLevel from '@/modules/academicLevel/CheckboxAcademicLevel.vue'

export default {
  components: {
    // CheckboxAcademicLevel
  },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      loading: false,
      academicLevels: [],
      title: ''
    }
  },
  computed: {
    ...mapState('SubjectGroup', ['subjectGroups'])
  },
  methods: {
    ...mapActions('SubjectGroup', ['createSubjectGroup', 'fetchSubjectGroups']),
    async save() {
      if (!this.$refs.form.validate()) return
      // if (this.academicLevels && this.academicLevels.length === 0) {
      //   this.$alert.error('Chưa chọn cấp học')
      //   return
      // }
      try {
        this.loading = true
        await this.createSubjectGroup({
          title: this.title
        })
        this.$alert.addSuccess()
        this.reset()
        this.dialog = false
      } catch (error) {
        this.$alert.addError()
      } finally {
        this.loading = false
      }
    },
    reset() {
      this.title = ''
      this.$refs.form.resetValidation()
    },
    cancel() {
      this.dialog = false
      this.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    }
  },
  watch: {
    state(state) {
      this.fetchSubjectGroups({})
      this.dialog = true
    }
  }
}
</script>
